export default __webpack_public_path__ + "static/media/background-logo.4f74ab78.png";